"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSIServerClientUtils = void 0;
const APIErrors_1 = require("./resources/APIErrors");
const Version_1 = require("./Version");
const bNow = (typeof (Date.now) === "function");
class FSIServerClientUtils {
    static GET_MODE_NODE() {
        return (typeof (window) === "undefined");
    }
    static JOIN_PATH(path, name) {
        path = path.replace(this.RGX_JOIN_PATH_1, "")
            .replace(this.RGX_JOIN_PATH_2, "");
        name = name.replace(this.RGX_JOIN_PATH_1, "")
            .replace(this.RGX_JOIN_PATH_2, "");
        if (path)
            path += "/";
        if (name)
            name += "/";
        return this.NORMALIZE_PATH(path + name);
    }
    static NOW() {
        return (bNow) ? Date.now() : new Date().getTime();
    }
    static ESCAPE_REG_EX(s) {
        return s.replace(this.RGX_ESCAPE_REG_EX, '\\$&');
    }
    static TRANSFORM_LOCAL_PATH(path) {
        if (path.match(this.RGX_TRANSFORM_LOCAL_PATH_2)) {
            path = path.replace(this.RGX_TRANSFORM_LOCAL_PATH_1, "$1://$2")
                .replace(this.RGX_TRANSFORM_LOCAL_PATH_2, "$1://");
        }
        path = path.replace(this.RGX_TRANSFORM_LOCAL_PATH_3, "/");
        return path;
    }
    static GET_BASE_PATH(path) {
        path = FSIServerClientUtils.NORMALIZE_PATH(path);
        const match = path.match(this.RGX_GET_BASE_PATH);
        return (match && match[0]) ? match[0] : "";
    }
    static NORMALIZE_PATH(path) {
        path = path.replace(this.RGX_NORMALIZE_PATH_1, "/")
            .replace(this.RGX_NORMALIZE_PATH_2, "")
            .replace(this.RGX_NORMALIZE_PATH_3, "");
        return path + "/";
    }
    static EXTRACT_LAST_DIR(path) {
        let dir;
        path = FSIServerClientUtils.NORMALIZE_PATH(path);
        const parts = path.split("/");
        parts.pop();
        if (parts.length > 0) {
            dir = parts.pop() || "";
        }
        else {
            dir = "";
        }
        if (parts.length > 0)
            path = FSIServerClientUtils.NORMALIZE_PATH(parts.join("/"));
        else
            path = "";
        return { path, dir, error: undefined, errorContent: [path] };
    }
    static FILE_AND_PATH(path) {
        let err;
        if (path.length < 3 || !path.match(this.RGX_FILE_AND_PATH_1) || path.match(this.RGX_FILE_AND_PATH_2)) {
            err = APIErrors_1.APIErrors.noValidFile;
        }
        path = FSIServerClientUtils.NORMALIZE_PATH(path)
            .replace(this.RGX_FILE_AND_PATH_2, "");
        const parts = path.split("/");
        const dir = parts.pop() || "";
        if (parts.length > 0) {
            path = FSIServerClientUtils.NORMALIZE_PATH(parts.join("/"));
        }
        else {
            err = APIErrors_1.APIErrors.invalidPath;
            path = "";
        }
        return { path, dir, error: err, errorContent: [path] };
    }
    static GET_PARENT_PATH(path) {
        path = path.replace(this.RGX_GET_PARENT_PATH_1, "");
        let ret = path.replace(this.RGX_GET_PARENT_PATH_2, "");
        ret = FSIServerClientUtils.NORMALIZE_PATH(ret);
        return ret;
    }
    static GET_SUB_DIR(basePath, path) {
        basePath = FSIServerClientUtils.NORMALIZE_PATH(basePath);
        path = FSIServerClientUtils.NORMALIZE_PATH(path);
        const regBasePath = new RegExp("^" + FSIServerClientUtils.ESCAPE_REG_EX(basePath));
        if (path.match(regBasePath))
            return path.replace(regBasePath, "");
        else
            return "";
    }
    static NORMALIZE_FILE_PATH(path) {
        const pd = FSIServerClientUtils.FILE_AND_PATH(path);
        return pd.path + pd.dir;
    }
    static REPLACE_LAST_DIR(path, newDir) {
        const pd = FSIServerClientUtils.EXTRACT_LAST_DIR(path);
        return FSIServerClientUtils.JOIN_PATH(pd.path, newDir);
    }
    static REPLACE_FILE_EXTENSION(path, ext) {
        return path.replace(this.RGX_REPLACE_FILE_EXTENSION, "." + ext);
    }
    static MAKE_RELATIVE_PATH(path) {
        path = path.replace(this.RGX_MAKE_RELATIVE_PATH[0], "")
            .replace(this.RGX_MAKE_RELATIVE_PATH[1], "")
            .replace(this.RGX_MAKE_RELATIVE_PATH[2], "")
            .replace(this.RGX_MAKE_RELATIVE_PATH[3], "")
            .replace(this.RGX_MAKE_RELATIVE_PATH[4], "")
            .replace(this.RGX_MAKE_RELATIVE_PATH[5], "");
        return FSIServerClientUtils.NORMALIZE_PATH(path);
    }
    static FORMAT_TIME_PERIOD(ms, includeMS = false, bHuman = true, translations) {
        if (!bHuman)
            translations = undefined;
        let nBlocks = 0;
        const msIn = ms;
        ms = Math.floor(ms);
        let res = "";
        let t = Math.floor(ms / 86400000);
        ms = ms % 86400000;
        if (t > 0) {
            res += this.translateTimePeriod(t, ["d", "day", "days"], translations);
        }
        t = Math.floor(ms / 3600000);
        ms = ms % 3600000;
        if (res.length || t > 0) {
            res += this.translateTimePeriod(t, ["h", "hour", "hours"], translations);
            if (bHuman && ++nBlocks === 2)
                return res.trim();
        }
        t = Math.floor(ms / 60000);
        ms = ms % 60000;
        if (res.length || t > 0) {
            res += this.translateTimePeriod(t, ["m", "minute", "minutes"], translations);
            if (bHuman && ++nBlocks === 2)
                return res.trim();
        }
        t = (includeMS || msIn > 1000) ? Math.floor(ms / 1000) : Math.ceil(ms / 1000);
        ms = ms % 1000;
        if (!includeMS || res.length || t > 0) {
            res += this.translateTimePeriod(t, ["s", "second", "seconds"], translations);
            if (bHuman && ++nBlocks === 2)
                return res.trim();
        }
        if (includeMS) {
            res += this.translateTimePeriod(ms, ["ms", "millisecond", "milliseconds"], translations);
        }
        return res.trim();
    }
    static GET_NEW_RELATIVE_PATH(path, basePath, targetPath, entry, options = {}, tries = 0) {
        let subPath = FSIServerClientUtils.GET_SUB_DIR(basePath, path);
        subPath = subPath.replace(this.RGX_GET_NEW_RELATIVE_PATH, "");
        if (options.fnRename)
            subPath = options.fnRename(entry, subPath, tries);
        return FSIServerClientUtils.NORMALIZE_PATH(targetPath) + subPath;
    }
    static translateTimePeriod(n, trans, translations) {
        if (!translations)
            return n + trans[0] + " ";
        else {
            const key = (n === 1) ? 1 : 2;
            if (translations[trans[key]])
                return n + " " + translations[trans[key]] + " ";
            else
                return n + trans[0] + " ";
        }
    }
}
exports.FSIServerClientUtils = FSIServerClientUtils;
FSIServerClientUtils.USERAGENT = 'FSI Server API Client JS ' + Version_1.LIB_VERSION;
FSIServerClientUtils.RGX_JOIN_PATH_1 = /^\//;
FSIServerClientUtils.RGX_JOIN_PATH_2 = /\/$/;
FSIServerClientUtils.RGX_ESCAPE_REG_EX = /[-/\\^$*+?.()|[\]{}]/g;
FSIServerClientUtils.RGX_TRANSFORM_LOCAL_PATH_1 = /^([a-zA-Z]):\\([^\\])/;
FSIServerClientUtils.RGX_TRANSFORM_LOCAL_PATH_2 = /^([a-zA-Z]):\\$/;
FSIServerClientUtils.RGX_TRANSFORM_LOCAL_PATH_3 = /\\/g;
FSIServerClientUtils.RGX_GET_BASE_PATH = /^[^/]*/;
FSIServerClientUtils.RGX_NORMALIZE_PATH_1 = /\/\//;
FSIServerClientUtils.RGX_NORMALIZE_PATH_2 = /^\/+/;
FSIServerClientUtils.RGX_NORMALIZE_PATH_3 = /\/+$/;
FSIServerClientUtils.RGX_FILE_AND_PATH_1 = /\//;
FSIServerClientUtils.RGX_FILE_AND_PATH_2 = /\/$/;
FSIServerClientUtils.RGX_GET_PARENT_PATH_1 = /\/+$/;
FSIServerClientUtils.RGX_GET_PARENT_PATH_2 = /\/[^/]*$/;
FSIServerClientUtils.RGX_REPLACE_FILE_EXTENSION = /\.[^.].*$/;
FSIServerClientUtils.RGX_MAKE_RELATIVE_PATH = [
    /^(\/\/[^/]+)/,
    /^([a-z]):\/+/i,
    /^\.+\/+/,
    /^\.+/,
    /^[^/]*:\/\//,
    /^\/+/
];
FSIServerClientUtils.RGX_GET_NEW_RELATIVE_PATH = /\/$/;
